import { Component, OnInit, ViewChild } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ToastrService } from "ngx-toastr";
import { TemplateRef } from "@angular/core";
import { Globals } from "../../common/global";
import { ApiCallingService } from "src/app/services/api-calling.service";
import { ConfigApi } from "src/app/config-api";

@Component({
  selector: "app-outstanding-amount",
  templateUrl: "./outstanding-amount.component.html",
  styleUrls: ["./outstanding-amount.component.css"],
})
export class OutstandingAmountComponent implements OnInit {
  modeltitle = "";
  page = 1;
  pageSize = 5;
  data = [];
  totalcount = 0;
  selectedStatus: string = "";
  detail: any = {};
  pendingPayments: any[] = [];
  @ViewChild("editModal") editModal!: TemplateRef<any>;
  operatorDetails: any;
  isEmployee: boolean = false;
  operatorId = "";

  constructor(
    private modalService: NgbModal,
    private toastr: ToastrService,
    public Globals: Globals,
    private apiCallingService: ApiCallingService
  ) {}

  ngOnInit(): void {
    this.isEmployee = this.Globals.getIsEmployee() === "true";

    const operatorDetails = this.isEmployee
      ? this.Globals.getUser()
      : this.Globals.getOperatorDetails();

    this.operatorId = this.isEmployee
      ? operatorDetails?.operator_id?._id
      : operatorDetails?.user_id;

    if (this.operatorId) {
      this.getList();
    } else {
      console.error("Operator ID is missing");
    }
  }

  getList(): void {
    const pageIndex = this.page > 0 ? this.page - 1 : 0;
    const params = new URLSearchParams({
      operator_id: this.operatorId,
      limit: this.pageSize.toString(),
      page: pageIndex.toString(),
      status: this.selectedStatus || "",
    });

    const url = `${ConfigApi.URLS.PENDING_PAYMENT}?${params.toString()}`;

    this.apiCallingService.callAPI({}, "GET", url).subscribe({
      next: (res) => {
        this.pendingPayments = res.data;
        this.totalcount = res.total;
      },
      error: (err) => {
        console.error("Error fetching pending payments", err);
      },
    });
  }

  requestPayment(item: any, type: string) {
    this.modeltitle = type === "waived" ? "Request Payment" : "Send Reminder";
    this.detail = { ...item, actionType: type };
    if (type === "waived") {
      this.detail.status = true;
    }
    this.modalService.open(this.editModal, {
      centered: true,
      backdrop: "static",
    });
  }

  viewInfo(item: any) {
    this.modeltitle = "View Details";
    this.detail = { ...item };
    this.modalService.open(this.editModal, {
      centered: true,
      backdrop: "static",
    });
  }

  togglePaymentStatus() {
    this.detail.status = !this.detail.status;
  }

  closeBtnClick() {
    this.modalService.dismissAll();
  }
  savePaymentStatus() {
    const payload: any = {
      paymentStatus: this.detail.actionType,
    };

    if (this.detail.actionType === "waived") {
      payload.status = this.detail.status;
    }

    this.apiCallingService
      .callAPI(
        payload,
        "POST",
        ConfigApi.URLS.PENDING_PAYMENT_UPDATE + "/" + this.detail._id
      )
      .subscribe(
        (res) => {
          if (this.apiCallingService.handleSuccess(res)) {
            this.toastr.success(res.msg);
            this.closeBtnClick();
            this.getList();
          } else {
            this.toastr.error(res.msg);
          }
        },
        (err) => {
          this.toastr.error(err.error?.msg || "Error occurred", "Error");
        }
      );
  }
  loadPage(page: number) {
    if (page) {
      this.page = page;
      this.getList();
    }
  }
  changeStatus() {
    this.page = 1;
    this.getList();
  }
}
